'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _error = require('./error.attribute');

var _list = require('./list.attribute');

var _list2 = _interopRequireDefault(_list);

var _fields = require('./fields.attribute');

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // List


exports.default = function (attributes, field) {
  (0, _fields2.default)(field);
  var errors = (0, _list2.default)(attributes).map(function (attribute) {
    return !attribute.reinit(attribute[field].format())[field].validate() ? attribute : null;
  }).filter(function (err) {
    return err !== null;
  });
  if (!errors.length) return;
  var errorData = errors.reduce(function (combined, attribute) {
    return {
      fields: [].concat((0, _toConsumableArray3.default)(combined.fields), [attribute.attribute]),
      names: [].concat((0, _toConsumableArray3.default)(combined.names), [attribute.label.default]),
      message: '' + combined.message + (combined.fields.length > 0 ? ',' : '') + ' ' + attribute.label.default + (attribute.errorMessage ? ' (' + attribute.errorMessage + ')' : '')
    };
  }, {
    fields: [],
    names: [],
    message: 'Please check the following:'
  });
  throw (0, _error.validationError)(errorData);
}; // Fields
// Error